import Api from '../Helper/Constant';
import API from '../Helper/FetchApi';

class OutboundService {
    /**@SAVE_OUTBOUND */
    async saveOutbound(reqBody: FormData) {
        try {
            console.log("=== FormData Debug Info ===");
            console.log("FormData object:", reqBody);
            
            // Log each field in the FormData
            console.log("FormData contents:");
            reqBody.forEach((value, key) => {
                console.log(`${key}:`, value);
            });
            
            return await API.fetchFormDataPost(Api.outboundSave, reqBody);
        } catch (error) {
            console.error('Error in saveOutbound:', error);
            throw error;
        }
    }

    /**@GET_OUTBOUND_LIST */
    async getOutboundList(page: number, pageSize: number) {
        return await API.fetchGet(`${Api.outboundList}?page=${page}&pageSize=${pageSize}`);
    }

    /**@GET_OUTBOUND_QUESTIONS */
    async getOutboundQuestions(id: string, dbName?: string) {
        console.log('Fetching outbound questions for ID:', id);
        console.log('Using endpoint:', `/outbound/${id}`);
        
        try {
            const url = dbName ? `/outbound/${id}?dbName=${dbName}` : `/outbound/${id}`;
            const response = await API.fetchGet(url);
            
            if (response && response.data) {
                console.log('Response data:');
                console.log('File data:', response.data.file);
                console.log('Questions:', response.data.file?.questions);
            }
            
            return response;
        } catch (error) {
            console.error('Error in getOutboundQuestions:', error);
            throw error;
        }
    }

    /**@GET_COMMENTS_FOR_QUESTION */
    async getCommentsForQuestion(questionId: string, outboundId: string, dbName?: string) {
        try {
            const url = dbName ? `/outbound/comment/list?questionId=${questionId}&outboundId=${outboundId}&dbName=${dbName}` : `/outbound/comment/list?questionId=${questionId}&outboundId=${outboundId}`;
            return await API.fetchGet(url);
        } catch (error) {
            console.error('Error in getCommentsForQuestion:', error);
            throw error;
        }
    }

    /**@CREATE_COMMENT */
    async createComment(commentData: { questionId: string; comment: string; commentType: 'outbound' | 'inbound' }, outboundId: string, dbName?: string) {
        try {
            const body = dbName ? { ...commentData, outboundId, dbName } : { ...commentData, outboundId };
            return await API.fetchPost('/outbound/comment/add', JSON.stringify(body));
        } catch (error) {
            console.error('Error in createComment:', error);
            throw error;
        }
    }

    /**@UPDATE_OUTBOUND_ANSWER */
    async updateOutboundAnswer({ outboundId, questionId, answer, dbName }: { outboundId: string, questionId: string, answer: string, dbName?: string }) {
        const body = dbName ? { outboundId, questionId, answer, dbName } : { outboundId, questionId, answer };
        return await API.fetchPut(Api.outboundUpdateAnswer, JSON.stringify(body));
    }

    async updateOutboundAttachment({ outboundId, questionId, fileName, dbName }: { outboundId: string, questionId: string, fileName: string, dbName?: string }) {
        const body = dbName ? { outboundId, questionId, fileName, dbName } : { outboundId, questionId, fileName };
        return await API.fetchPut(Api.outboundUpdateAttachment, JSON.stringify(body));
    }

    /**@DELETE_OUTBOUND_ATTACHMENT */
    async deleteOutboundAttachment({ outboundId, questionId, attachmentId, dbName }: { outboundId: string, questionId: string, attachmentId: string, dbName?: string }) {
        const body = dbName ? { outboundId, questionId, attachmentId, dbName } : { outboundId, questionId, attachmentId };
        return await API.fetchDelete(Api.outboundDeleteAttachment, JSON.stringify(body));
    }

    /**@DOWNLOAD_OUTBOUND_ATTACHMENT */
    async downloadOutboundAttachment({ outboundId, questionId, attachmentId, fileName, dbName }: { outboundId: string, questionId: string, attachmentId: string, fileName: string, dbName?: string }) {
        const body = dbName ? { outboundId, questionId, attachmentId, fileName, dbName } : { outboundId, questionId, attachmentId, fileName };
        return await API.fetchPost(Api.outboundDownloadAttachment, JSON.stringify(body));
    }

    /**@DELETE_OUTBOUND */
    async deleteOutbound(id: string) {
        return await API.fetchDelete(`${Api.outboundDelete}/${id}`, null);
    }

    /**@ADD_COLLABORATOR */
    async addCollaborator(outboundId: string, collaboratorEmail: string) {
        try {
            const body = { outboundId, collaboratorEmail };
            return await API.fetchPost('/outbound/collaborator/add', JSON.stringify(body));
        } catch (error) {
            console.error('Error in addCollaborator:', error);
            throw error;
        }
    }

    /**@REMOVE_COLLABORATOR */
    async removeCollaborator(outboundId: string, collaboratorEmail: string) {
        try {
            const body = { outboundId, collaboratorEmail };
            return await API.fetchDelete('/outbound/collaborator/remove', JSON.stringify(body));
        } catch (error) {
            console.error('Error in removeCollaborator:', error);
            throw error;
        }
    }

    /**@GET_COLLABORATORS */
    async getCollaborators(outboundId: string) {
        try {
            return await API.fetchGet(`/outbound/collaborators?outboundId=${outboundId}`);
        } catch (error) {
            console.error('Error in getCollaborators:', error);
            throw error;
        }
    }
}

export default new OutboundService(); 